import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, Subscription, withLatestFrom } from 'rxjs';
import { Site } from 'src/app/model/site';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, TreeNode } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { StandardDesignParameters, StandardMtmaLayout, StandardPageLayout, StandardTruncateString } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { DevicesTree } from 'src/app/model/device-tree';
import { EDeviceModel, EDeviceThermoModel } from 'src/app/conf/device-models';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { User } from 'src/app/model/user';
import { Lang } from 'src/app/model/lang';
import { DEFAULT_LANG } from 'src/app/conf/languages';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { selectCurrentSite, selectSites } from 'src/app/store/site/site.selector';
import { selectCurrentLang, selectIsDraftMode, selectIsImpersMode, selectUser } from 'src/app/store/user/user.selector';
import * as DeviceThActions from 'src/app/store/device-th/device-th.actions';
import { DevicesThGroupsV2Data, ThGroup } from 'src/app/model/api/data-rest';
import { selectThGroupsListV2 } from 'src/app/store/device-th/device-th.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { DeviceStatus } from 'src/app/model/device-status';
import { selectDevicesStatus } from 'src/app/store/device/device.selector';
import { ManageThGroupsDialogComponent } from './manage-groups-dialog/manage-groups.dialog.component';
import { ShareDeviceDialogComponent } from '../device/components/share-device-dialog/share-device.dialog.component';
import * as InvitationsActions from 'src/app/store/invitations/invitations.actions';
import { ThFinalUsersComponent } from '../shared/components/th-final-users/th-final-users.component';

@Component({
	selector: 'app-devices-th-list',
	templateUrl: './devices-th-list.component.html',
	providers: [ConfirmationService, DialogService]
})

export class DevicesThListComponent implements OnInit, OnDestroy {
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;
	thGroupsList$: Observable<DevicesThGroupsV2Data | undefined>;
	thGroupsListSub: Subscription | undefined;
	// thDeviceStatus: ThDeviceStatus;
	// thDeviceStatus$: Observable<ThDeviceStatus | undefined>;
	// thDeviceStatusSub: Subscription | undefined;

	devicesStatus: DeviceStatus[] = [];
	devicesStatus$: Observable<DeviceStatus[] | undefined>;
	devicesStatusSub: Subscription | undefined;

	thOwnedGroups: ThGroup[];
	thSharedGroups: ThGroup[];

	currentSite: Site;
	thGroupsList: DevicesThGroupsV2Data;

	sites: Site[];
	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;

	devicesTree: DevicesTree;
	deviceNode: TreeNode[] = [];

	thDevicesMap: Map<number, { siteId: number, node: DevicesTree }> = new Map();

	groupTrees: { [groupId: number]: TreeNode[] } = {};

	loading: boolean = true;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	isDraftMode: boolean;
	isDraftMode$: Observable<boolean | undefined>;
	isDraftModeSub: Subscription;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	LG_WIDTH = StandardDesignParameters.LG_WIDTH;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private router: Router,
		private route: ActivatedRoute,
		public app: AppComponent
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.store.dispatch(DeviceThActions.getDevicesThListV2());
		this.subscribeAll();
		this.onResize();
		/*setTimeout(() => { TODO CHANGE
			this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Devices list' } }));
		}, 2000);*/
	}

	initSelectors(): void {
		this.thGroupsList$ = this.store.select(selectThGroupsListV2);
		this.site$ = this.store.select(selectCurrentSite);
		this.sites$ = this.store.select(selectSites);
		this.devicesStatus$ = this.store.select(selectDevicesStatus);
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.currentUser$ = this.store.select(selectUser);
		this.isDraftMode$ = this.store.select(selectIsDraftMode);
		// this.thDeviceStatus$ = this.store.select(selectThDeviceStatus);
	}

	subscribeAll(): void {
		this.siteSub = this.site$?.pipe(
			filter(cs => !!cs)
		).subscribe((currentSite) => {
			this.currentSite = currentSite;
			this.onCurrentSiteChange();
		});
		this.devicesStatusSub = this.devicesStatus$?.pipe(filter(ds => ds.length > 0))
			.subscribe(
				devicesStatus => {
					this.devicesStatus = devicesStatus;
				}
			);
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.currentUserSub = this.currentUser$?.subscribe(
			(currentUser) => {
				this.currentUser = currentUser;
			}
		);
		this.isDraftModeSub = this.isDraftMode$.subscribe(
			(isDraftMode) => {
				this.isDraftMode = isDraftMode;
			}
		);
	}

	// necessary to trigger after every change site, we are based on siteSub (currentSite)
	onCurrentSiteChange() {
		this.store.dispatch(DeviceThActions.getDevicesThListV2());
		// withLatestFrom thGroupsListSub -> thermo/v2/groups is last GET to response and we need to wait it for do everything else
		this.thGroupsListSub = this.thGroupsList$.pipe(
			withLatestFrom(
				this.site$?.pipe(filter(cs => !!cs)),
				this.sites$
			)
		).subscribe(([thGroupsList, currentSite, sites]) => {
			this.loading = true;
			this.thGroupsList = thGroupsList;
			this.currentSite = currentSite;
			this.sites = sites;
			this.checkThGroups();
			this.buildThDevicesMap();
		});
	}

	ngOnDestroy(): void {
		this.store.dispatch(NotificationsActions.resetTopbarTitleId());
		this.thGroupsListSub?.unsubscribe();
		this.siteSub?.unsubscribe();
		this.sitesSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isDraftModeSub?.unsubscribe();
		// this.thDeviceStatusSub?.unsubscribe();
	}

	// aux of buildThDevicesMap()
	auxBuildThDevicesMapTree(site: Site, device: DevicesTree) {
		if (this.isThermo(device)) { // includes THONEGW, if Thermo is under a GW ModelId not includes we cannot do this !!
			this.thDevicesMap.set(device.Id, { siteId: site.Id, node: device });
		}

		if (device.Children?.length) {
			for (const child of device.Children) {
				this.auxBuildThDevicesMapTree(site, child);
			}
		}
	}

	// called by Subscribers
	// create a thDevicesMap: { key: device.Id => value: { siteId: site.Id, node: DevicesTree } }
	buildThDevicesMap() {
		this.thDevicesMap.clear();

		if (this.sites && this.sites.length > 0) {
			for (const s of this.sites) {
				if (s.DevicesTree) {
					this.auxBuildThDevicesMapTree(s, s.DevicesTree);
				}
			}
		}
		this.buildGroupTrees();
	}

	// aux of buildGroupTrees()
	// convertToNode create TreeNode for this.groupTrees
	convertToNode(node: DevicesTree, deviceSiteId: number): TreeNode {
		return {
			key: String(node.Id), // is used for trigger expand and for table row key
			data: {
				id: node.Id,
				name: node.Name,
				description: node.Description,
				// productId: dt.ProductId, // undefined
				modelId: node.ModelId,
				icon: this.generateIcon(node),
				siteId: deviceSiteId, // (Connect, not ThGroup)
			},
			expanded: node.Expand ?? false,
			children: node.Children?.map(c => this.convertToNode(c, deviceSiteId)) ?? []
		};
	}

	// called by Subscribers
	// build a groupTrees: { groupId number : TreeNode[] } we'll use in p-treeTable
	buildGroupTrees() {
		this.groupTrees = {};

		if (this.thOwnedGroups?.length > 0) {
			for (const group of this.thOwnedGroups) {
				// filter by site
				if (group.siteId !== this.currentSite.Id && group.siteId !== -1) continue;

				const nodeList: TreeNode[] = [];

				for (const dev of group.items) {
					// found is value from thDevicesMap: { siteId: number, node: DevicesTree }
					const found = this.thDevicesMap.get(dev.deviceid);

					if (!found) continue;

					// convertToNode create TreeNode
					// = { key (deviceId number), expanded (bool), children (TreeNode[]),
					// .. data: { id, name, description, modelid, icon, siteId (Connect, not ThGroup) } }
					const node = this.convertToNode(found.node, found.siteId);

					nodeList.push(node);
				}

				this.groupTrees[group._id] = nodeList;
			}
		}
		this.loading = false;
	}

	generateIcon(device: DevicesTree): string {
		let icon = '';
		if (device.ModelId !== EDeviceModel.MultiIO) { // unused here but just in case ..
			icon = 'cm-' + DeviceIcon[device.ModelId];
		} else {
			icon = 'cm-' + device.IconName.toLowerCase() || 'cm-' + DeviceIcon[device.ModelId] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				return convertDbStandartIcon(device.IconName);
			}
			default: {
				return convertOldIcon(icon);
			}
		}
	}

	checkThGroups(): void {
		this.thOwnedGroups = this.thGroupsList?.content.ownedGroups;
		this.thSharedGroups = this.thGroupsList?.content.sharedGroups;
	}

	isThermo(row: any): boolean {
		return Object.values(EDeviceThermoModel).includes(row.ModelId);
	}

	// TODO: We need to check expand with new struct
	onDeviceExpand(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = true;
		}
	}

	onDeviceCollapse(event: any) {
		if (event !== undefined && event.node !== undefined && event.node.data !== undefined && event.node.data.Expand !== undefined) {
			event.node.data.Expand = false;
		}
	}

	getStatus(nodeId: number): string {
		if (this.devicesStatus.length > 0) {
			let device: DeviceStatus;
			this.devicesStatus.forEach(dev => {
				if (dev.Id === nodeId) {
					device = dev;
				}
			});
			if (device === undefined || !device.Online) {
				return this.translate.instant('OFFLINE');
			} else if (device.Errored) {
				return this.translate.instant('GENERIC_ERROR');
			} else {
				return this.translate.instant('ONLINE');
			}
			//return ((device) ? (device.Errored) ? this.translate.instant('GENERIC_ERROR') : ((device.Online) ? this.translate.instant('ONLINE') : this.translate.instant('OFFLINE')) : this.translate.instant('GENERIC_ERROR'));
		}
		return '';
	}

	getStatusColor(nodeId: any): string {
		if (this.devicesStatus.length > 0) {
			let device: DeviceStatus;
			this.devicesStatus.forEach(dev => {
				if (dev.Id === nodeId) {
					device = dev;
				}
			});
			if (device === undefined || !device.Online) {
				return 'danger';
			} else if (device.Errored) {
				return 'warning';
			} else {
				return 'success';
			}
			//return (device !== undefined && device.Errored) ? 'warning' : ((device !== undefined && device.Online) ? 'success' : 'danger');
		}
		return '';
	}

	selectDevice(rowNode, deviceId: number): void {
		if (this.isInThisSite(rowNode)) {
			this.store.dispatch(DeviceActions.passwordVerifySupportReset());
			const urlRoute = '../devices/' + deviceId;
			this.router.navigate([urlRoute], { relativeTo: this.route });
		}
	}

	getBgColorSchedule(ownGroup: ThGroup): any {
		return (ownGroup.color) ? { 'background-color': ownGroup.color, 'opacity': '50%' } : { 'background-color': '#607d8b', 'opacity': '50%' };
	}

	isInThisSite(rowNode: any): boolean {
		return rowNode.node.data.siteId === this.currentSite.Id
	}

	rowClass(rowNode): string {
		if (this.isInThisSite(rowNode)) {
			if (rowNode.level === 0) {
				return "surface-400 hover:bg-blue-200 border-top-1 border-bottom-1 border-bluegray-900 cursor-pointer";
			} else { // slaves in this site
				return "";
			}
		} else { // not in this site
			if (rowNode.level === 0) { // th and thgw
				return "opacity-60 surface-400 border-top-1 border-bottom-1 border-bluegray-900";
			} else { // slaves invalid
				return "opacity-60";
			}
		}
	}

	manageThGroups(): void {
		this.ref = this.dialogService.open(ManageThGroupsDialogComponent, {
			header: this.translate.instant('ASSOCIATE_TH_GROUPS_TO_SITE') + ' ' + this.currentSite.Name,
			width: '75vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				currentSite: this.currentSite,
			},
		});
	}

	// reloadFromServer() {
	// 	this.store.dispatch(DeviceThActions.getDevicesThListV2());
	// }

	share(ownGroup: ThGroup): void {
		this.store.dispatch(InvitationsActions.resetInvitationsShareDialog());
		this.ref = this.dialogService.open(ShareDeviceDialogComponent, {
			header: this.translate.instant('SHARE_GROUP_TH') + ': ' + ownGroup.name,
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				isThGroup: true,
				thGroup: ownGroup,
			},
		});
	}

	finalUsers(ownGroup: ThGroup): void {
		this.store.dispatch(InvitationsActions.resetInvitationsShareDialog());
		this.ref = this.dialogService.open(ThFinalUsersComponent, {
			header: this.translate.instant('ENABLED_USERS') + ': ' + ownGroup.name,
			width: '70vw',
			breakpoints: { '1600px': '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				thGroup: ownGroup,
			},
		});
	}

	siteIsCurrentlyOwned(): boolean {
		return this.currentSite !== undefined && this.currentSite.CurrentlyOwned;
	}

	thGroupIsUnmatchedWithAllSites(ownGroup: ThGroup): boolean {
		return ownGroup.siteId === -1;
	}

	thGroupIsUnmatchedWithCurrentSite(ownGroup: ThGroup): boolean {
		return ownGroup.siteId !== this.currentSite?.Id;
	}

	thGroupIsMatchedWithCurrentSite(group: ThGroup): boolean {
		return group.siteId === this.currentSite?.Id;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	getSplitString(str: string): string {
		return StandardTruncateString.getSplitString(this.screenWidth, str, 15, 50, 100);
	}
}
